import { Col, DatePicker, Modal, Row, Table } from "antd";
import _ from "lodash";
import moment from "moment-timezone";
// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React, { Component } from "react";
import { areArraysEqual } from "../../utils/arrays";
import { showErrorToast } from "@src/appV2/lib/Notifications";

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'hasExpirations' implicitly has an 'any' type.
function RequirementsTable({ hasExpirations, expirations, onDateChange, rowSelection, ...props }) {
  const columns = [
    {
      title: "Name",
      key: "name",
      dataIndex: "name",
    },
  ];

  if (hasExpirations) {
    // FIXME: Automatically disabled during ESLint config update
    // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter '_text' implicitly has an 'any' type.
    const renderDatePicker = (_text, record) => {
      const isSelected = rowSelection.selectedRowKeys.includes(record._id);

      if (isSelected) {
        const expiryDate = expirations[record._id];
        return (
          <DatePicker
            value={expiryDate && moment(expiryDate)}
            onChange={(date) => onDateChange(record._id, date)}
          />
        );
      }

      return <DatePicker disabled value={null} />;
    };

    columns.push({
      title: "Expires",
      key: "expires",
      /* @ts-expect-error FIXME this wrong type */
      render: renderDatePicker,
    });
  }

  return (
    <Table
      size="small"
      rowSelection={rowSelection}
      columns={columns}
      rowKey="_id"
      pagination={false}
      {...props}
    />
  );
}
// FIXME: Automatically disabled during ESLint config update
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class RequirementsModal extends Component<any, any> {
  state = this.stateFromInit();

  // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'prevProps' implicitly has an 'any' type.
  componentDidUpdate(prevProps) {
    // this is necessary so checklist can be controlled by local state but also over-written by new props
    if (!areArraysEqual(prevProps.init, this.props.init)) {
      // eslint-disable-next-line react/no-did-update-set-state -- guarded by prop comparison; legacy class component
      this.setState(this.stateFromInit());
    }
  }

  stateFromInit() {
    const { init, isFacility = false } = this.props;
    // FIXME: Automatically disabled during ESLint config update
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const defaultKeys: any = {};

    if (isFacility) {
      // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'requirement' implicitly has an 'any' type.
      defaultKeys.selectedRowKeys = init.map((requirement) => requirement);
    } else {
      // @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'requirement' implicitly has an 'any' type.
      defaultKeys.selectedRowKeys = init.map(({ requirement }) => requirement);
    }

    return {
      ...defaultKeys,
      // @ts-expect-error TODO(typecheck-unify): TS7006,TS7031 Parameter 'expirations' implicitly has an 'any' type.
      expirations: init.reduce((expirations, { requirement, expires }) => {
        expirations[requirement] = expires;
        return expirations;
      }, {}),
      addedRequirements: [],
      removedRequirements: [],
      updatedRequirements: [],
    };
  }

  // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'selectedRowKeys' implicitly has an 'any' type.
  updateSelectedKeys = (selectedRowKeys) => {
    this.setState({ selectedRowKeys });
  };

  // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'record' implicitly has an 'any' type.
  handleRequirementChange = (record, selected) => {
    if (selected) {
      // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'state' implicitly has an 'any' type.
      this.setState((state) => {
        // Edge Case: Check if requirement is removed before adding to prevent duplicates
        // Eg: If user removes existing requirement and adds again
        const isRemoved = state.removedRequirements.includes(record._id);
        if (isRemoved) {
          return {
            removedRequirements: _.without(state.removedRequirements, record._id),
          };
        }

        return { addedRequirements: [...state.addedRequirements, record._id] };
      });
    } else {
      // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'state' implicitly has an 'any' type.
      this.setState((state) => {
        // Edge Case: Check if requirement is added before removing to prevent duplicates
        // Eg: If user adds new requirement and remove the new requirement
        const isAdded = state.addedRequirements.includes(record._id);
        if (isAdded) {
          return {
            addedRequirements: _.without(state.addedRequirements, record._id),
          };
        }

        return {
          removedRequirements: [...state.removedRequirements, record._id],
        };
      });
    }
  };

  // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'id' implicitly has an 'any' type.
  updateExpiration = (id, date) => {
    const { expirations } = this.state;
    expirations[id] = date;
    // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'state' implicitly has an 'any' type.
    this.setState((state) => ({
      expirations,
      updatedRequirements: [...state.updatedRequirements, id],
    }));
  };

  cancel = () => {
    this.setState(this.stateFromInit());
    this.props.cancel();
  };

  getAddedReqDocs = () => {
    const { addedRequirements, expirations } = this.state;

    // FIXME: Automatically disabled during ESLint config update
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const addedReqDocs: any[] = [];

    // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'reqId' implicitly has an 'any' type.
    addedRequirements.forEach((reqId) => {
      addedReqDocs.push({
        requirement: reqId,
        expires: expirations[reqId],
      });
    });

    return addedReqDocs;
  };

  getUpdatedReqDocs = () => {
    const { addedRequirements, updatedRequirements, expirations } = this.state;

    // FIXME: Automatically disabled during ESLint config update
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const updatedReqDocs: any[] = [];

    // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'reqId' implicitly has an 'any' type.
    updatedRequirements.forEach((reqId) => {
      const isNewReq = addedRequirements.includes(reqId);
      if (isNewReq) {
        return;
      }

      updatedReqDocs.push({
        requirement: reqId,
        expires: expirations[reqId],
      });
    });

    return updatedReqDocs;
  };

  handleOk = () => {
    const { addedRequirements, removedRequirements, updatedRequirements, selectedRowKeys } =
      this.state;
    const { hasExpirations, requireExpirations, save } = this.props;

    if (
      addedRequirements.length === 0 &&
      removedRequirements.length === 0 &&
      updatedRequirements === 0
    ) {
      // no change was made
      this.cancel();
      return;
    }

    const addedReqDocs = this.getAddedReqDocs();
    const updatedReqDocs = this.getUpdatedReqDocs();

    const requirements = {
      addedReqDocs,
      updatedReqDocs,
      removedRequirements,
      selectedRequirements: selectedRowKeys,
    };

    if (!hasExpirations) {
      save(requirements);
      return;
    }

    const isExpiryMissing =
      addedReqDocs.find((doc) => !doc.expires) || updatedReqDocs.find((doc) => !doc.expires);

    if (isExpiryMissing) {
      showErrorToast("Heads up: one or more requirements are missing expiration dates");
      if (requireExpirations) {
        return;
      }
    }

    save(requirements);
    this.setState(this.stateFromInit());
  };

  render() {
    const { width, title, isVisible, frame, hasExpirations, documents } = this.props;
    const { selectedRowKeys, expirations } = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.updateSelectedKeys,
      onSelect: this.handleRequirementChange,
    };

    return (
      <Modal
        width={width || 600}
        title={title}
        visible={isVisible}
        onOk={this.handleOk}
        onCancel={this.cancel}
      >
        {frame ? (
          <Row>
            <Col span={14}>{frame}</Col>
            <Col span={10}>
              <h3>Add Fulfilled Requirements:</h3>
              <RequirementsTable
                rowSelection={rowSelection}
                hasExpirations={hasExpirations}
                expirations={expirations}
                dataSource={documents}
                onDateChange={this.updateExpiration}
              />
            </Col>
          </Row>
        ) : (
          <RequirementsTable
            rowSelection={rowSelection}
            hasExpirations={hasExpirations}
            expirations={expirations}
            dataSource={documents}
            onDateChange={this.updateExpiration}
          />
        )}
      </Modal>
    );
  }
}
